import React, { useEffect, useState } from 'react';
import { Table, Button, Space, Popconfirm, Alert } from 'antd';
import { EditOutlined, DeleteOutlined, CheckCircleOutlined, CloseCircleOutlined, DeleteFilled } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { deleteTruck, getTrucksList } from '../../store/slices/truckSlice';
import { useNavigate } from 'react-router';
import TableComponent from '../../components/TableComponent';
import Can from '../../permission/Can';

const TruckList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [reload, setReload] = useState(false)
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const showPopconfirm = (truckId) => {
        setOpen(truckId);
    };

    const handleDeleteTruck = async (id) => {
        try {
            setConfirmLoading(true);

            const resultAction = await dispatch(deleteTruck(id))
            if (deleteTruck.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || "Deleted")
                setAlertType('success')
                setReload(!reload)
                setOpen(false);
                setConfirmLoading(false);
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            }
        } catch (error) {
            setConfirmLoading(false);
            setAlertMessage("Error deleting truck")
            setAlertType('error')
            setOpen(null);
        }
        
    };

    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };

    const columns = [
        {
            title: 'Truck Number',
            dataIndex: 'truck_num',
            key: 'truck_num',
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'Order Per Day',
            dataIndex: 'orders_per_day',
            key: 'orders_per_day',
        },
        {
            title: 'CBM Value',
            dataIndex: 'cbm',
            key: 'cbm',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (__, data) => (
                <Space>
                    <Can permission="edit_truck">
                        <Button onClick={() => navigate('/truck/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
                    </Can>
                    <Can permission="delete_truck">
                        <Popconfirm
                            title="Delete confirmation"
                            description="Do you want to delete this?"
                            open={open == data?._id}
                            icon={<DeleteFilled />}
                            onConfirm={() => handleDeleteTruck(data?._id)}
                            okButtonProps={{ loading: confirmLoading }}
                            onCancel={handleCancel}
                        >
                            <Button icon={<DeleteOutlined />} onClick={() => showPopconfirm(data?._id)} size="small" danger>Delete</Button>
                        </Popconfirm>
                    </Can>
                </Space>
            ),
        },
    ];

    // const data = [
    //     {
    //         id: 1,
    //         name: 'John Doe',
    //         email: 'john@example.com',
    //         role: 'Admin',
    //     },
    //     {
    //         id: 2,
    //         name: 'Jane Smith',
    //         email: 'jane@example.com',
    //         role: 'User',
    //     },
    //     {
    //         id: 3,
    //         name: 'Bob Johnson',
    //         email: 'bob@example.com',
    //         role: 'User',
    //     },
    // ];

    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Trucks</h1>
                <Can permission="create_truck">
                    <Button type="primary" onClick={(e) => navigate('/truck/add')}>Add Truck</Button>
                </Can>
            </div>
            {alertMessage && (
                <Alert
                    message={alertMessage}
                    type={alertType}
                    showIcon
                    icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                    closable
                    onClose={() => setAlertMessage('')}
                    style={{
                        marginBottom: 24,
                        borderRadius: '8px',
                    }}
                />
            )}
            {/* <Table
                columns={columns}
                dataSource={data}
                loading={isLoading}
                rowKey="id"
                pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    total,
                    showSizeChanger: true,
                    showTotal: (total) => `Total ${total} items`,
                }}
                onChange={handleTableChange}
            /> */}
            <TableComponent
                listData={getTrucksList}
                columns={columns}
                reload={reload}
                placeholder="Search trucks..."
            />
        </div>
    );
};

export default TruckList;